import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { PartyService, SalesPlanService, PurchaseOrderService } from "../../../services/index";

@Component({
  selector: "addEditInvoice",
  templateUrl: "./addYearPlan.html",
})
export class yearPlanAdd {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  menu: any;
  agentdata: any;
  show_det: boolean = false;
  invoicedata: any = {
    design_no: "",
    agent_name: "",
  };
  seasonList = ["APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC","JAN", "FEB", "MAR"];
  agentEntry: any = [];
  finyearList = [];
  mode: string;
  saveEvent: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD AGENT DEDUCTION",
          title: "ADD AGENT DEDUCTION",
          tabParent: "SALES_ORDER",
          mode: "Add",
          data: row,
          name: "ADD AGENT DEDUCTION",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let invoicedata = Object.assign({}, tabObj.params["data"]);
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);
      this.invoicedata = invoicedata;
      this.invoicedata.disper = invoicedata.disper;
    }
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }
    if (this.mode == "View" || this.mode == "Edit") {
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  finCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesPlanService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private combo2Service: Combo2Service,
    private partyService: PartyService
  ) {
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.finyearCombo()
    if (this.mode == "Add") {
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }
  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "design" && nxtRow.length < 0) {
      nxtInd = nxtInd + 1;
      $("#" + "total1" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  calcTotal(ind) {
    this.data.invoiceList[ind].total = Number(this.data.invoiceList[ind].a1) + Number(this.data.invoiceList[ind].a2) + Number(this.data.invoiceList[ind].a3) + Number(this.data.invoiceList[ind].a4) + this.data.invoiceList[ind].a5 + this.data.invoiceList[ind].a6 + this.data.invoiceList[ind].a7 + this.data.invoiceList[ind].a8 + this.data.invoiceList[ind].a9 + this.data.invoiceList[ind].a10 + this.data.invoiceList[ind].a11 + this.data.invoiceList[ind].a12
    // console.log(this.data.invoiceList[ind].total);
    this.data.invoiceList[ind].ord_total_target = this.data.invoiceList[ind].total + (this.data.invoiceList[ind].total * 0.5);
    this.calcGrandEntrytot()
  }

  calcGrandEntrytot() {
    let tot = 0;
    let ord_total = 0;
    let a1tot = 0;
    let a2tot = 0;
    let a3tot = 0;
    let a4tot = 0;
    let a5tot = 0;
    let a6tot = 0;
    let a7tot = 0;
    let a8tot = 0;
    let a9tot = 0;
    let a10tot = 0;
    let a11tot = 0;
    let a12tot = 0;
    if (this.show_det) {
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        if (i == this.data.invoiceList.length - 1) {
          this.data.invoiceList[i].a1 = a1tot;
          this.data.invoiceList[i].a2 = a2tot;
          this.data.invoiceList[i].a3 = a3tot;
          this.data.invoiceList[i].a4 = a4tot;
          this.data.invoiceList[i].a5 = a5tot;
          this.data.invoiceList[i].a6 = a6tot;
          this.data.invoiceList[i].a7 = a7tot;
          this.data.invoiceList[i].a8 = a8tot;
          this.data.invoiceList[i].a9 = a9tot;
          this.data.invoiceList[i].a10 = a10tot;
          this.data.invoiceList[i].a11 = a11tot;
          this.data.invoiceList[i].a12 = a12tot;
          this.data.invoiceList[i].total = tot;
          this.data.invoiceList[i].ord_total_target = ord_total;
          return
        }
        else {
          a1tot += this.data.invoiceList[i].a1;
          a2tot += this.data.invoiceList[i].a2;
          a3tot += this.data.invoiceList[i].a3;
          a4tot += this.data.invoiceList[i].a4;
          a5tot += this.data.invoiceList[i].a5;
          a6tot += this.data.invoiceList[i].a6;
          a7tot += this.data.invoiceList[i].a7;
          a8tot += this.data.invoiceList[i].a8;
          a9tot += this.data.invoiceList[i].a9;
          a10tot += this.data.invoiceList[i].a10;
          a11tot += this.data.invoiceList[i].a11;
          a12tot += this.data.invoiceList[i].a12;
          tot += this.data.invoiceList[i].total;
          ord_total += this.data.invoiceList[i].ord_total_target;

        }
      }
    }
  }
  getMasterDetails() {
    let params = {
      year: this.invoicedata.finyear,
      state: this.show_det,
    };

    this.salesinvservice.getYearAgentTarget(params).then((res: any) => {

      this.data.invoiceList = res.data;
      console.log("data.invoiceList", this.data.invoiceList);
      this.calcGrandtot();
      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);
      this.selectYear();
    });
  }

  selectYear() {
    let obj = this.finyearList.find(o => o.finyear === this.invoicedata.finyear);
    let params = {
      year: obj.fin_id,
    };
    this.seasonList;
  }
  calcGrandtot() {
    if (this.show_det) {
      let a1tot = 0;
      let a2tot = 0;
      let a3tot = 0;
      let a4tot = 0;
      let a5tot = 0;
      let a6tot = 0;
      let a7tot = 0;
      let a8tot = 0;
      let a9tot = 0;
      let a10tot = 0;
      let a11tot = 0;
      let a12tot = 0;
      let atot = 0;
      let aord_tot = 0;
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        const data = this.data.invoiceList[i];
        a1tot += Number(data.a1)
        a2tot += Number(data.a2)
        a3tot += Number(data.a3)
        a4tot += Number(data.a4)
        a5tot += Number(data.a5)
        a6tot += Number(data.a6)
        a7tot += Number(data.a7)
        a8tot += Number(data.a8)
        a9tot += Number(data.a9)
        a10tot += Number(data.a10)
        a11tot += Number(data.a11)
        a12tot += Number(data.a12)
        atot += Number(data.total)
        aord_tot += Number(data.ord_total_target)
      }
      let temp: any = {};
      temp.agent_name = "GR.TOTAL";
      temp.a1 = a1tot;
      temp.a2 = a2tot;
      temp.a3 = a3tot;
      temp.a4 = a4tot;
      temp.a5 = a5tot;
      temp.a6 = a6tot;
      temp.a7 = a7tot;
      temp.a8 = a8tot;
      temp.a9 = a9tot;
      temp.a10 = a10tot;
      temp.a11 = a11tot;
      temp.a12 = a12tot;
      temp.total = atot;
      temp.ord_total_target = aord_tot;
      this.data.invoiceList.push(temp)
    }
  }

  onnextdet() {
    this.show_det = true;  
    this.agentEntry = this.data.invoiceList;
    this.calcInchargerTot(this.agentEntry)
    this.getMasterDetails()
  }
  onbackdet() {
    this.show_det = false;
    this.agentEntry.splice(this.agentEntry.length - 1)
    this.data.invoiceList = this.agentEntry;
  }

  calcInchargerTot(Inchdata){
    let data = {
      incharger: 'GR.TOTAL',
      a1: 0,
      a2: 0,
      a3: 0,
      a4: 0,
      a5: 0,
      a6: 0,
      a7: 0,
      a8: 0,
      a9: 0,
      a10: 0,
      a11: 0,
      a12: 0,
      ord_total_target: 0,
      total: 0
    }
    Inchdata.forEach(e => {
      data.a1 += Number(e.a1)
      data.a2 += Number(e.a2)
      data.a3 += Number(e.a3)
      data.a4 += Number(e.a4)
      data.a5 += Number(e.a5)
      data.a6 += Number(e.a6)
      data.a7 += Number(e.a7)
      data.a8 += Number(e.a8)
      data.a9 += Number(e.a9)
      data.a10 += Number(e.a10)
      data.a11 += Number(e.a11)
      data.a12 += Number(e.a12)
      data.ord_total_target += Number(e.ord_total_target)
      data.total += Number(e.total)

    });
    Inchdata.push(data)
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.invoicedata.finyear = res.data[0].finyear;
      that.invoicedata.fin_id = res.data[0].fin_id;
      this.selectYear();
    });
  }

  oncheckemptyrow() {
    this.data.invoiceList = this.data.invoiceList.slice(0, -1);
    this.agentEntry = this.agentEntry.slice(0, -1)
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    params["agentdata"] = JSON.stringify(this.agentEntry);
    params["type"] = this.menu.param;

    let that = this;
    let temp = this.agentEntry[0].total - this.data.invoiceList[this.data.invoiceList.length - 1].total
    swal({
      title: "Are You Sure To Save The Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok,Proceed!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .saveYearPlanDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal(res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/yearPlanAdd/addYearPlan.ts